module.exports = "   \n\n\n    <input-text label=\"Фамилия\" model=\"$ctrl.model.LastName\"  class=\"col-4 col-xl-4 col-sm-12\" ></input-text>\n    <input-text label=\"Имя\" model=\"$ctrl.model.Name\"  class=\"col-4 col-xl-4 col-sm-12 my-sm-3\"></input-text>\n    <input-text-switch  label=\"Отчество\" model=\"$ctrl.model.MiddleName\"  switch=\"$ctrl._haveSecondName\" class=\"col-4 col-xl-4 col-sm-12\"  ></input-text-switch>\n   \n\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/html/fio.html
// module id = 139
// module chunks = 1